import { render, staticRenderFns } from "./GameLayout.vue?vue&type=template&id=1c46d24b&scoped=true"
import script from "./GameLayout.vue?vue&type=script&lang=js"
export * from "./GameLayout.vue?vue&type=script&lang=js"
import style0 from "./GameLayout.vue?vue&type=style&index=0&id=1c46d24b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46d24b",
  null
  
)

export default component.exports